function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
    }

    const input = document.createElement("input");
    input.value = text;
    input.style.position = "fixed";
    input.style.opacity = "0";
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);

    return Promise.resolve();
}

function shareCopyLink() {
    const buttons = document.querySelectorAll("[data-copy-link]");

    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            const url = button.getAttribute("data-copy-link");

            copyToClipboard(url).then(() => {
                button.classList.add("is-copied");

                clearTimeout(button.copyLinkTimeout);
                button.copyLinkTimeout = setTimeout(() => {
                    button.classList.remove("is-copied");
                }, 2000);
            });
        });
    });
}

module.exports = { shareCopyLink };
